import React from 'react';
import PropTypes from 'prop-types';
import ArticleCard from './ArticleCard/ArticleCard';
import PodcastCard from './PodcastCard/PodcastCard';
import { ContentCardWrapper } from './wrappers/ContentCardWrapper';
import PhotoCard from './PhotoCard/PhotoCard';
import DiscussionContent from './DiscussionContent/DiscussionContent';
import LinkContent from './LinkContent/LinkContent';

const ContentCard = ({
    type,
    // eslint-disable-next-line react/prop-types
    hash,
    location,
    title,
    link,
    description,
    isSingleContent,
    contentLink,
    image,
    article, // editorial content props
    podcast, // community podcast props
    handleOnClickMetricEmit,
    handleLinkClickMetricEmit,
}) => {
    const characterLimit = link ? 650 : 420;
    const hasDiscussionContent = title || description;

    return (
        <ContentCardWrapper
            contentType={type}
            contentLink={contentLink}
            handleOnClickMetricEmit={handleOnClickMetricEmit}
            render={() => {
                if (type === 'editorial-content') {
                    const {
                        wink,
                        contentTitle,
                        contentDescription,
                        contentImage,
                    } = article;

                    return (
                        <ArticleCard
                            wink={wink}
                            title={contentTitle}
                            description={contentDescription}
                            image={contentImage}
                            location={location}
                        />
                    );
                }

                if (type === 'community-podcast') {
                    const {
                        wink,
                        contentTitle,
                        contentDescription,
                        contentImage,
                        audioSrc,
                    } = podcast;
                    return (
                        <PodcastCard
                            wink={wink}
                            title={contentTitle}
                            description={contentDescription}
                            image={contentImage}
                            audioSrc={audioSrc}
                            showAudioPlayer={false}
                            location={location}
                        />
                    );
                }

                return (
                    <>
                        {hasDiscussionContent && (
                            <DiscussionContent
                                title={title}
                                description={description}
                                isSingleContent={isSingleContent}
                                characterLimit={characterLimit}
                                content={{ type, hash }}
                                showMoreButton={
                                    !isSingleContent &&
                                    description?.length >= characterLimit
                                }
                                location={location}
                                handleLinkClickMetricEmit={
                                    handleLinkClickMetricEmit
                                }
                            />
                        )}

                        {image && !link && (
                            <PhotoCard
                                previewImage={{
                                    ...image,
                                }}
                            />
                        )}

                        {/* eslint-disable-next-line react/prop-types */}
                        {link?.previewTitle && (
                            <LinkContent
                                isSingleContent={isSingleContent}
                                description={description}
                                preview={link}
                                location={location}
                                contentLink={contentLink}
                            />
                        )}
                    </>
                );
            }}
        />
    );
};

export default ContentCard;

const ImageType = PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
});

ContentCard.propTypes = {
    type: PropTypes.oneOf([
        'editorial-content',
        'editorial-podcast',
        'community-discussion',
        'community-photo',
        'community-link',
        'community-podcast',
    ]),
    location: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.shape({
        externalUrl: PropTypes.string,
    }),
    description: PropTypes.string,
    isSingleContent: PropTypes.bool,
    contentLink: PropTypes.string,
    image: ImageType,
    article: PropTypes.shape({
        wink: PropTypes.string,
        contentTitle: PropTypes.string,
        contentDescription: PropTypes.string,
        contentImage: ImageType,
    }),
    podcast: PropTypes.shape({
        wink: PropTypes.string,
        contentTitle: PropTypes.string,
        contentDescription: PropTypes.string,
        contentImage: ImageType,
        audioSrc: PropTypes.string,
    }),
    handleOnClickMetricEmit: PropTypes.func,
    handleLinkClickMetricEmit: PropTypes.func,
};

ContentCard.defaultProps = {
    type: undefined,
    // eslint-disable-next-line react/default-props-match-prop-types
    hash: undefined,
    location: null,
    title: null,
    link: null,
    description: null,
    isSingleContent: false,
    contentLink: null,
    image: null,
    article: null,
    podcast: null,
    handleOnClickMetricEmit: () => null,
    handleLinkClickMetricEmit: () => null,
};
